<template>
  <div class="statisticsdetail">
    <div class="userInfo">
      <div class="baseInfo">
        <img
          class="img"
          :src="sales.avatarUrl"
          alt
        />
        <div class="info">
          <div class="name">{{sales.realName}}</div>
          <div class="team">{{sales.orgName}}</div>
        </div>
      </div>
      <div class="functionalForm">
        <el-input v-model="input3" placeholder="请输入客户名称或手机号" class="input-with-select">
          <el-button slot="append" @click="chaxun">查询</el-button>
        </el-input>
        <timeChuli @btnClick="btnClick" style="margin-right: 0px !important;"></timeChuli>
      </div>
    </div>

    <dataTable
      ref="dataTable"
      :flush="fresh"
      :inSerachFilte="inSerachFilte"
      :inTableData="tableDataConfig"
      :inAjax="tableAjaxConfig"
      :ispagination="true"
    ></dataTable>
  </div>
</template>

<script>
  import timeChuli from "../../components/timeChuli";
  import dataTable from "../../../components/commonComponents/dataTable";
  import GlobalUtil from "../../../utils/globalUtil.js";

  export default {
    components: {
      timeChuli,
      dataTable
    },
    data() {
      return {
        input3: "",
        //用于tableData组件刷新，tableData检测到fresh值发生变化就会刷新数据
        fresh: "",
        // 用于匹配搜索数据，返回新的数据
        inSerachFilte: {},
        //tableData组件参数配置
        tableDataConfig: {
          //表头及字段配置
          tHead: [
            {
              name: "客户姓名",
              field: "nickName"
            },
            {
              name: "手机号",
              field: "phone"
            },
            {
              name: "成为客户时间",
              field: "createDate"
            },
            {
              name: "订单数（单）",
              field: "orderCount"
            },
            {
              name: "订单总额（元）",
              field: "orderAmount"
            }
          ],
          //自动渲染
          tData: [],
          //自动渲染
          total: 0,
          actionBtWidth: "250",
          //配置是否显示多选框
          isMultiple: false,
          dispatchp: true,
          //配置是否显示排序
          isRank: true
        },
        tableAjaxConfig: {
          url: this.$url.getMemberSalesDetailList,
          method: "post",
          data: {
            pageNumber: 1,
            pageSize: 15,
            queryObj: {}
          }
        },
        searchObj: {},
        salesId: ""
      };
    },
    created() {
      this.sales = JSON.parse(GlobalUtil.readCookie("salesInfo"));
      this.searchObj["entMid"] = this.sales.id;
      this.searchObj["timeFlag"] = '1';
      this.inSerachFilte = {queryObj: this.searchObj};

    },
    destroyed() {
      GlobalUtil.delCookie("salesId");
    },
    methods: {
      chaxun() {
        this.searchObj["nameOrPhone"] = this.input3;
        this.inSerachFilte = {
          queryObj: this.searchObj
        };
      },
      btnClick(e) {
        this.searchObj["timeFlag"] = e;
        this.inSerachFilte = {
          queryObj: this.searchObj
        };
      }
    }
  };
</script>

<style lang='less' scoped>
  .statisticsdetail {
    padding: 24px 30px;
    height: 100%;
    width: 100%;
    background-color: #fff;
    box-sizing: border-box;

    .userInfo {
      width: 100%;
      display: flex;
      padding-bottom: 25px;
      border-bottom: 1px solid rgba(224, 230, 235, 1);
      justify-content: space-between;

      .baseInfo {
        display: flex;

        .img {
          height: 42px;
          width: 42px;
          border-radius: 50%;
          margin-right: 10px;
        }

        .name {
          font-size: 16px;
          color: rgba(51, 51, 51, 1);
          margin-bottom: 5px;
        }

        .team {
          font-size: 12px;
          color: rgba(153, 153, 153, 1);
        }
      }

      .functionalForm {
        display: flex;
        align-items: center;
      }

      .input-with-select {
        width: 270px;
        border: 1px solid rgba(221, 221, 221, 1);
        border-right: 0px;
        border-radius: 3px;
        margin-right: 20px;

        ::v-deep .el-input__inner {
          width: 200px;
          height: 29px !important;
        }

        .el-date-editor {
          width: 360px;
        }

        ::v-deep .el-input-group__append {
          background: rgba(89, 204, 225, 1);
          border: 1px solid rgba(89, 204, 225, 1);
          color: white !important;
        }
      }

      ::v-deep .alltime {
        margin-right: 0px !important;
      }
    }
  }
</style>
